import { Link } from 'react-router-dom';
import SiteLogo from './SiteLogo';
import { siteNavItems, navHref } from './siteNav';

interface SiteFooterProps {
  current: string;
}

const systemSpecs = [
  { label: 'Instrument', value: 'XAUUSD' },
  { label: 'Platform', value: 'MetaTrader 5' },
  { label: 'Recorded', value: 'Jun — Sep 2026' },
];

const tradingPrinciples = [
  { icon: 'ri-shield-check-line', label: 'No martingale, grid, or hedging' },
  { icon: 'ri-percent-line', label: 'Fixed risk on every single trade' },
  { icon: 'ri-robot-2-line', label: 'Fully automated, no manual input' },
  { icon: 'ri-book-read-line', label: 'Every entry and exit logged' },
];

function SiteFooter({ current }: SiteFooterProps) {
  return (
    <footer className="w-full bg-background-200 border-t border-background-300">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-16 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-6 lg:col-span-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
              <div>
                <SiteLogo />
                <p className="mt-6 text-[14px] leading-relaxed text-foreground-700 max-w-[300px]">
                  XAUUSD-focused MT5 Expert Advisor.
                </p>
                <div className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                  <span className="text-[11px] font-data tracking-[0.16em] text-foreground-600 whitespace-nowrap">
                    MT5 · XAUUSD
                  </span>
                </div>
              </div>

              <div className="lg:pt-1">
                <p className="text-[11px] font-data tracking-[0.22em] text-foreground-500">
                  HOW IT TRADES
                </p>
                <ul className="mt-5 flex flex-col gap-3.5">
                  {tradingPrinciples.map((principle) => (
                    <li key={principle.label} className="flex items-center gap-3">
                      <span className="w-6 h-6 rounded-md bg-primary-100 flex items-center justify-center flex-none">
                        <i className={`${principle.icon} text-[13px] text-primary-700`}></i>
                      </span>
                      <span className="text-[13px] leading-snug text-foreground-700">
                        {principle.label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="md:col-span-3 lg:col-span-3">
            <p className="text-[11px] font-data tracking-[0.22em] text-foreground-500">EXPLORE</p>
            <nav className="mt-6 flex flex-col gap-3.5">
              {siteNavItems.map((item) => (
                <Link
                  key={item.key}
                  to={navHref(item, current)}
                  className="group inline-flex items-center gap-2 text-[14px] text-foreground-700 hover:text-primary-700 transition-all duration-200 cursor-pointer hover:translate-x-0.5 whitespace-nowrap"
                >
                  <span className="w-0 h-px bg-primary-500 transition-all duration-200 group-hover:w-3"></span>
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3 lg:col-span-3">
            <p className="text-[11px] font-data tracking-[0.22em] text-foreground-500">SYSTEM</p>
            <ul className="mt-6 flex flex-col">
              {systemSpecs.map((spec) => (
                <li
                  key={spec.label}
                  className="flex items-center justify-between gap-4 py-3 border-b border-background-300/70 first:pt-0 last:border-b-0"
                >
                  <span className="text-[12px] text-foreground-500">{spec.label}</span>
                  <span className="text-[12px] font-data text-foreground-900 whitespace-nowrap">
                    {spec.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-background-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[12px] leading-relaxed text-foreground-500 max-w-[560px]">
            Trading involves risk. Past trading results do not guarantee future results.
          </p>
          <p className="text-[12px] font-data tracking-wider text-foreground-500 whitespace-nowrap">
            © 2026 GOLDEA · XAUUSD
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;